// extracted by mini-css-extract-plugin
export default {"container":"OptionsSkeleton_container__kIJNA","items":"OptionsSkeleton_items__K95Sp","item":"OptionsSkeleton_item__JMNi5"};